export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.4-1231.15",
  commitId: "bea1d158a5713d9a801a8d2d3bd1e526ebb51bb3",
  commitTime: "2026-06-04T12:31:15.000Z",
});
